import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "sponsors",
  class: "max-w-[75%] mx-auto pb-24 sm:pb-32"
}
const _hoisted_2 = { class: "mx-auto" }
const _hoisted_3 = { class: "flex items-center text-xl md:text-2xl font-medium" }

import Marquee from "@selemondev/vue3-marquee";
import "@selemondev/vue3-marquee/dist/index.css";

import {
  Crown,
  Vegan,
  Ghost,
  Puzzle,
  Squirrel,
  Cookie,
  Drama,
} from "lucide-vue-next";

interface sponsorsProps {
  icon: string;
  name: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Sponsors',
  setup(__props) {

const sponsors: sponsorsProps[] = [
  {
    icon: "puzzle",
    name: "Association Ikigai",
  },
  {
    icon: "crown",
    name: "Psychologie TSA",
  },
  {
    icon: "vegan",
    name: "Éducation Inclusive",
  },
  {
    icon: "ghost",
    name: "Insertion Pro",
  },
  {
    icon: "squirrel",
    name: "Design UX",
  },
  {
    icon: "cookie",
    name: "Neurodiversité",
  },
  {
    icon: "drama",
    name: "Innovation Digitale",
  },
];

const iconMap: Record<
  string,
  | typeof Crown
  | typeof Vegan
  | typeof Ghost
  | typeof Puzzle
  | typeof Squirrel
  | typeof Cookie
  | typeof Drama
> = {
  crown: Crown,
  vegan: Vegan,
  ghost: Ghost,
  puzzle: Puzzle,
  squirrel: Squirrel,
  cookie: Cookie,
  drama: Drama,
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-lg md:text-xl text-center mb-6" }, "Nos partenaires et domaines d'expertise", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Marquee), {
        class: "gap-[3rem]",
        pauseOnHover: true,
        fade: true,
        innerClassName: "gap-[3rem]"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sponsors, ({ icon, name }) => {
            return _createElementVNode("div", { key: name }, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(iconMap[icon]), {
                  class: "mr-2",
                  "stroke-width": "3"
                })),
                _createTextVNode(" " + _toDisplayString(name), 1)
              ])
            ])
          }), 64))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})